import { formatDate } from './format.js'

const WEEKDAY_NAMES = [
  'domingo',
  'segunda',
  'terça',
  'quarta',
  'quinta',
  'sexta',
  'sábado',
]

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function formatRelative(date, baseDate = new Date()) {
  const target = startOfDay(date)
  const base = startOfDay(baseDate)
  const diffDays = Math.round((target - base) / 86400000)

  if (diffDays === 0) return 'Hoje'
  if (diffDays === -1) return 'Ontem'
  if (diffDays === 1) return 'Amanhã'

  if (Math.abs(diffDays) < 7) {
    return WEEKDAY_NAMES[target.getDay()]
  }

  return formatDate(target, 'DD MMM')
}
